import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { StrategyPermissionsCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { StrategyPermissionTable } from "./table";

export default function StrategyPermission() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Permissions de stratégie");
  }, []);

  return (
    <Routes>
      <Route index element={<StrategyPermissionTable />} />

      <Route path=":id" element={<StrategyPermissionsCard />} />
    </Routes>
  );
}
